import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { ChangeDeviceService } from './shared/services/change-device.service';
import { FinancialData } from './shared/interfaces/data/financial-data.interface';

import { ThemeService } from './shared/services/theme.services';
import { AppService } from './app.service';
import { FinancialProducts } from './shared/interfaces/financial-simulator/financial-products.interface';
import { AuthService } from './shared/auth/auth.service';
import { LoadDataService } from './shared/services/load-data.service';
import { QuotationMapperService } from './shared/mappers/quotation-mapper';
import { QuotationRequest } from './shared/interfaces/financial-simulator/quotation-interface';
import { QuotationReverseMapperService } from './shared/mappers/quotation-mapper-reverse';
import { FinancialProductMapperService } from './shared/mappers/financial-product-mapper';
import { OperationReverseMapperService } from './shared/mappers/operation-reverse-mapper';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    token: string = '';

    appData: any;

    financialData!: FinancialData;
    financialProducts!: FinancialProducts[];

    quotationRequest!: QuotationRequest;

    brand = 'Jaguar';
    model = 'XE';
    language = 'es';

    price = 0;

    isPortraitDevice = false;
    isLoading = true;
    isAuthorised = false;

    constructor(
        private responsive: BreakpointObserver,
        private translate: TranslateService,
        private theme: ThemeService,
        private authService: AuthService,
        private dataAppService: AppService,
        private loadDataService: LoadDataService,
        private changeDeviceService: ChangeDeviceService,
        private operationReverseMapperService: OperationReverseMapperService,
        private quotationMapperService: QuotationMapperService,
        private quotationReverseMapperService: QuotationReverseMapperService,
        private financialProductMapperService: FinancialProductMapperService
    ) {
        translate.setDefaultLang(this.language);
        translate.use(this.language);

        this.theme.loadTheme('Jaguar');
        this.isAuthorised = this.authService.getIsValid();
        /*
        this.authService.userToken.subscribe(value => {
          console.log("token saved");
          this.token = this.authService.token;
          this.cargarDatos();
        });
        */
    }

    ngOnInit() {
        this.checkToken();
    }

    checkToken() {
        this.token = this.authService.token;
        this.isLoading = false;
        this.authService.userToken.subscribe(value => {
            this.token = this.authService.token;
            this.cargarDatos();
        });
    }

    cargarDatos() {
        this.isLoading = true;

        if (this.token)
            this.getDataFromService(this.token);
        else
            this.getDataFromService('3264153492714');  //Order Ejemplo

        this.checkIfIsPortraitDevice();
    }

    checkIfIsPortraitDevice() {
        this.responsive.observe([Breakpoints.TabletPortrait, Breakpoints.HandsetPortrait]).subscribe((result) => {

          if(result.matches) this.isPortraitDevice = true;
          else this.isPortraitDevice = false;


            this.changeDeviceService.changeDevice(this.isPortraitDevice);
        });
    }

    getDataFromService(token : string) {
        let financialDataAux: FinancialData;

        console.log('function getDataFromService');
        //Check if token is valid
        this.appData = this.dataAppService.getCarFinancingConditions(token).subscribe({
            next: (value) => {
                this.isAuthorised = true;
                this.authService.setIsValid(this.isAuthorised);

                this.brand = value.vehicle.brand == 'Land Rover' ? 'Jaguar' : value.vehicle.brand; //TODO Ver Como controlar Marcas
                this.model = value.vehicle.model;
                //this.price = value.financialData.totalAmount;
                this.theme.loadTheme(this.brand);

                this.dataAppService.data = this.operationReverseMapperService.transform(value);
                const salesAgentId = this.dataAppService.data.userData.salesman ?  this.dataAppService.data.userData.salesman: '';
                const partnerStoreIds = this.dataAppService.data.userData.store ? this.dataAppService.data.userData.store : '';

                this.appData = this.dataAppService.getVendor(salesAgentId, partnerStoreIds).subscribe({
                    next: (value) => {
                        this.dataAppService.data.userData.vendor = value[0].sellerCode;
                        this.dataAppService.data.userData.agreement = value[0].agreement;
                    },
                    error: (err) => {
                        console.error("Service 'getCarFinancingConditions' emitted an error: " + err)
                    },
                    complete: () => {
                        const financialProductsRequestAux = this.financialProductMapperService.transform(this.dataAppService.data);

                        this.appData = this.dataAppService.getFinancialProducts(financialProductsRequestAux).subscribe({
                            next: (value) => {
                                this.dataAppService.data.financialData.financialProducts = value.financialProducts;
                                this.financialProducts = value.financialProducts;
                            },
                            error: (err) => {
                                console.error("Service 'getFinancialProducts' emitted an error: " + err);
                            },
                            complete: () => {
                                console.log("Service 'getFinancialProducts' emitted the complete notification");
                                this.quotationRequest = this.quotationMapperService.transform(this.dataAppService.data);
                                this.appData = this.loadDataService.getConditions(this.quotationRequest).subscribe({
                                    next: (value) => {
                                        const channel = this.dataAppService.data.financialData.channel; //El channel se 'pierde'
                                        const secureCode = this.dataAppService.data.financialData.secureCode; //El channel se 'pierde'

                                        this.dataAppService.data.financialData = this.quotationReverseMapperService.transform(value);
                                        this.dataAppService.data.financialData.channel = channel;
                                        this.dataAppService.data.financialData.secureCode = secureCode;
                                        this.dataAppService.data.vehicleData.annualMileage = this.dataAppService.data.financialData.annualMileages;

                                        console.log(this.dataAppService.data.financialData)

                                        this.financialData = this.dataAppService.data.financialData;
                                        this.dataAppService.data.financialData.amountFinanced = this.dataAppService.data.financialData.price - this.dataAppService.data.financialData.downPaymentGrossAmount;
                                        this.financialData.financialProducts = this.financialProducts;
                                        this.isLoading = false;
                                    },
                                    error: (err) => {
                                        console.error("Service 'getConditions' emitted an error: " + err);
                                    },
                                    complete: () => {
                                        console.log("Service 'getConditions' emitted the complete notification");
                                    },
                                });
                            },
                        });
                    },
                });
            },
            error: (err) => {
                console.error("Service 'getCarFinancingConditions' emitted an error: " + err)
            },
            complete: () => {
                console.log("Service 'getCarFinancingConditions' emitted the complete notification");
            },
        });
    }

    getDataFromJson() {
        console.log('function getDataFromJson');

        this.authService.setIsValid(true);

        this.appData = this.dataAppService.getVehicleDataMocked().subscribe({
            next: (value) => {
                this.brand = value.brand;
                this.model = value.model;
                this.price = value.price;
                this.theme.loadTheme(this.brand);
            },
            error: (err) => {
                console.error("Service 'getVehicleDataMocked' emitted an error: " + err)
            },
            complete: () => {
                //console.log("Service 'getVehicleDataMocked' emitted the complete notification");

                this.appData = this.dataAppService.getFinancialProductsMocked().subscribe({
                    next: (value) => {
                        this.financialProducts = value;
                    },
                    error: (err) => {
                        //console.error("Service 'getFinancialProductsMock' emitted an error: " + err)
                    },
                    complete: () => {
                        //console.log("Service 'getFinancialProductsMock' emitted the complete notification");

                        this.appData = this.dataAppService.getCarFinancialDataMocked().subscribe({
                            next: (value) => {
                                this.financialData = value;
                                this.financialData.price = this.price;
                                this.financialData.financialProducts = this.financialProducts;

                                this.isLoading = false;
                            },
                            error: (err) => {
                                //console.error("Service 'getCarFinancialDataMock' emitted an error: " + err)
                            },
                            complete: () => {
                                //console.log("Service 'getCarFinancialDataMock' emitted the complete notification");
                            },
                        });
                    },
                });
            },
        });
    }

    //-------------------------//
    //------EVENT METHODS------//
    //-------------------------//

    ngOnDestroy() {
        if (this.appData) {
            this.appData.unsubscribe();
            console.log('unsubscribe appData');
        }
    }
}
